import { FC } from 'react';
import { cn } from 'src/utils/utility';

export const CardSkeleton: FC<{ showSecondRow?: boolean }> = ({ showSecondRow = false }) => {
  return (
    <div
      className={cn('relative overflow-hidden border border-neutral-20 rounded-8 w-full px-12 py-10 flex flex-col gap-y-2 bg-white', 'animate-pulse')}
      style={{
        boxShadow: '0 4px 7px 0 rgba(112, 149, 221, 0.12), 0 1px 0 0 #DFDFDF',
      }}
    >
      {/* Header */}
      <div className='flex items-center justify-between border-b border-neutral-20 pb-10'>
        {/* Left: Icon + Title */}
        <div className='flex-1 flex items-center gap-8'>
          {/* Icon Circle */}
          <div className='w-16 h-16 bg-neutral-20 rounded-full' />
          {/* Title - split into two lines to match strict "image" look usually implies detailed skeleton */}
          <div className='flex flex-col gap-8'>
            <div className='h-8 w-48 bg-neutral-20 rounded flow-row' />
            <div className='h-6 w-[64px] bg-neutral-20 rounded' />
          </div>
        </div>

        {/* Header Right Columns */}
        <div className='flex items-center gap-8'>
          <div className='px-6 w-[74px] flex justify-end'>
            <div className='h-8 w-32 bg-neutral-20 rounded' />
          </div>
          <div className='w-[1px] h-[10px] bg-neutral-20' />
          <div className='pl-6 w-[74px]'>
            <div className='h-8 w-[56px] bg-neutral-20 rounded' />
          </div>
        </div>
      </div>

      {/* Body */}
      <div className='flex flex-col gap-4 py-6'>
        {/* Row 1 */}
        <div className='flex items-center'>
          <div className='h-6 w-32 bg-neutral-20 rounded' />
          <div className='flex-1 flex items-center gap-8 justify-end'>
            <div className='px-6 w-[74px] flex justify-end'>
              <div className='h-8 w-32 bg-neutral-20 rounded' />
            </div>
            <div className='w-[1px] h-[10px] bg-neutral-20' />
            <div className='pl-6 w-[74px]'>
              <div className='h-8 w-32 bg-neutral-20 rounded' />
            </div>
          </div>
        </div>

        {/* Row 2 */}
        {showSecondRow && (
          <div className='flex items-center'>
            <div className='h-6 w-32 bg-neutral-20 rounded' />
            <div className='flex-1 flex items-center gap-8 justify-end'>
              <div className='px-6 w-[74px] flex justify-end'>
                <div className='h-8 w-32 bg-neutral-20 rounded' />
              </div>
              <div className='w-[1px] h-[10px] bg-neutral-20' />
              <div className='pl-6 w-[74px]'>
                <div className='h-8 w-32 bg-neutral-20 rounded' />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
